<template>
  <v-card id="panel-container">
    <v-card-title @click="showInfos = !showInfos">
      {{ title }}
      <v-icon
        v-if="showInfos"
        style="color: #009999; position: absolute; right: 35px"
      >
        mdi-arrow-down-drop-circle-outline
      </v-icon>
      <v-icon v-else style="color: #009999; position: absolute; right: 35px">
        mdi-arrow-up-drop-circle-outline
      </v-icon>
    </v-card-title>

    <v-expand-transition>
      <div v-if="showInfos">
        <v-card-title> - ... ... .. </v-card-title>
        <v-card-title> - .. ... .... </v-card-title>
        <v-card-title> - .. .. ..... . </v-card-title>
        Si vous souhaitez en savoir plus à ce sujet, vous pouvez lire les<a
          href="https://support.explorama.app/category/50-conseils-et-astuces"
          target="_blank"
        >
          articles suivants</a
        >
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: 'dropDownPanel',
  components: {},
  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showInfos: false,
    };
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style>
#panel-container {
  background-color: white;
  width: 95%;
  border-radius: 10px;
  color: #009999;
  font-size: 1.4em;
  padding: 0.5em;
  margin: auto;
}
</style>
